import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { useCallback } from 'react'
import { ButtonOrLoader } from '../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../baseComponents/PermissionChecker'
import FormRenderer from '../../../../forms/FormRenderer'
import { FormRender } from '../../../../forms/FormRenderer/types'
import TwinForm from '../../../../forms/TwinForm'
import useIsLoading from '../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import './customerNotes.sass'
import { ActivityDisplayParent } from '../../CustomerActivity'

interface CustomerNotesProps extends CustomerNotesBodyProps {}

export const CustomerNotes: React.FC<CustomerNotesProps> = ({ userPermissions, ...logic }) => {
    const {t} = useTwinTranslation()
    const title = t('notesCustomer', 'Notas del Cliente')
    return (
        <div className='grid grid-cols-2 gap-30 flex-auto customer_notes'>
            <ActivityDisplayParent userPermissions={userPermissions} />
            <CustomerNotesBody userPermissions={userPermissions} title={title} {...logic} />
        </div>
    )
}

type CustomerNotesBodyProps = & CustomerNotesBodyLogicProps & ComponentWithPermissions & {
    basicData: CustomerModelType | null
    title?: string
}

export const CustomerNotesBody: React.FC<CustomerNotesBodyProps> = ({ basicData, getData, userPermissions, title }) => {
    const {t} = useTwinTranslation()
    const { myOnSubmit, endLoading, startLoading, loading } = useCustomerNotesBodyLogic({getData})
    const fields: FormRender<CustomerModelType> = [
        {
            cols: 1,
            title: title || undefined,
            className: 'customer_notes_grid',
            elements: [
                {
                    name: 'notes',
                    component: 'TwinEditor',
                    defaultValue: basicData?.notes || '',
                    className: 'h-300'
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                }
            ]
        }
    ]

    return (
        <TwinForm action='/api/app/customer/updateCustomer' onSubmit={myOnSubmit} beforeSubmitHandler={startLoading} onError={endLoading} className='customer_notes_form'>
            <FormRenderer sections={fields} antiUnsaveTrigger={true} />
            <PermissionChecker userPermissions={userPermissions} permission='update'>
                <div className='flex justify-end items-center mt-40 customer_notes_save_button'>
                    <ButtonOrLoader textButton={t('save', 'Guardar')} buttonIsDisabled={loading} />
                </div>
            </PermissionChecker>
        </TwinForm>
    )
}

interface CustomerNotesBodyLogicProps {
    getData: () => Promise<void>
}

const useCustomerNotesBodyLogic = ({getData}: CustomerNotesBodyLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()

    const myOnSubmit = useCallback(() => {
        endLoading()
        getData()
    }, [endLoading, getData])

    return { startLoading, endLoading, loading, myOnSubmit }
}

export default CustomerNotes